export const props = {
  sort: {
    type: String,
    default: () => undefined
  },
  page: {
    type: Number,
    default: () => undefined
  },
  start: {
    type: String,
    default: () => undefined
  },
  end: {
    type: String,
    default: () => undefined
  },
  type: {
    type: String,
    default: () => undefined
  },
  lat: {
    type: Number,
    default: () => undefined
  },
  lon: {
    type: Number,
    default: () => undefined
  },
  loc: {
    type: String,
    default: () => undefined
  },
  clubs: {
    type: String,
    default: () => undefined
  },
  amenities: {
    type: String,
    default: () => undefined
  },
  types: {
    type: [String],
    default: () => undefined
  }
}
